import React,{Component} from 'react';
import { cookie } from "./approach/base"

import {
  HashRouter,
  Route,
  Switch
} from 'react-router-dom'
import Login from 'pages/Login/index';
import App from './App';
import Bidding from './Bidding';

export default class route extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route path='/' component={RouteIndex}/>
        </Switch>
      </HashRouter>
    )
  }
}
class RouteIndex extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    this.judgeRoute();
  }
  componentWillMount(){
    // this.judgeRoute();
  }
  componentWillUpdate=()=>{
    // this.judgeRoute();
  };
  componentDidUpdate(){
    this.judgeRoute();
  }
  judgeRoute=()=>{
    const loginStatus = cookie.get('loginStatus')
    const { pathname } = this.props.location;
    console.log(this.props.location,loginStatus)
    if(pathname !== '/' && pathname !== '/history'){
        if(loginStatus){
            if(pathname === '/login'){
                this.props.history.replace('/manage/bidding');
            }
        }else{
            if(pathname !== '/login'){
                this.props.history.replace('/login');
            }
        }
    }
  };
  render(){
    return <Switch style={{width:'100%',height:'100%'}}>
      <Route path="/login" exact component={Login}/>
      <Route path="/manage" component={App}/>
      <Route path="/" component={Bidding}/>
    </Switch>
  }
}
